APP.MODULES = window.APP.MODULES || {};
// --------------------------------------------------------------------------
// Used on the subpages, runs on load, called again when loading a new page
// --------------------------------------------------------------------------

APP.MODULES.page = function() {
    'use strict';

    function polyfillSVG() {
        svg4everybody();
    }

    function counters(container) {
        $('.js-counter', container).each(function() {
            var number = $(this),
                originalValue = String(number.text()),
                originalNumber = parseFloat(originalValue.replace(/,/g, '')),
                decimals = originalNumber.countDecimals();

            $({ Counter: 0 }).animate({ Counter: originalNumber }, {
                duration: 1000,
                easing: 'easeOutCubic',
                step: function () {
                    number.text(numberWithCommas(this.Counter.toFixed(decimals)));
                },
                complete : function() {
                    number.text(originalValue);
                }
            });
        });
    }

    function getMaxGraphValue(graphs) {
        graphs = graphs || $('.js-horizontal-barchart-wrapper', APP.page);

        if (!graphs.length) return;

        graphs.each(function(index, value) {
            var graph = $(value),
                charts = $('.js-chart', graph),
                maxGraphPoint = 0;

            if (!charts.length) return;

            if (!graph.data('max')) {
                charts.each(function(index, value) {
                    var chart = $(value),
                        chartPoints = [],
                        maxChartPoint = 0;

                    if (chart.data('points')) {
                        chartPoints = convertArrayToNumbers(String(chart.data('points')).replace(/,/g, '').split(";"));

                        for (var i = 0; i < chartPoints.length; i++) {
                            if (chartPoints[i] > maxChartPoint) {
                                maxChartPoint = chartPoints[i];
                            }
                        }

                        if (maxChartPoint > maxGraphPoint) {
                            maxGraphPoint = maxChartPoint;
                        }
                    }
                });
            }
            else {
                maxGraphPoint = graph.data('max');
            }

            if (graph.data('timegraph')) {
                var maxMinutes = Math.round(secondsToMinutes(maxGraphPoint-1));

                maxGraphPoint = (Math.floor(maxMinutes/10)*10+10)*60 - 1;
            }


            graph.data('maxGraphPoint', maxGraphPoint);
        });
    }

    function createGraphAxis(graph, chartsWrapper, exampleValue) {
        var axisContainer = $('.js-infograph-axis', chartsWrapper),
            numericValue = 0,
            index = 0,
            unit = "",
            unitPosition = "start",
            labels = String($('.js-chart', chartsWrapper).eq(0).attr('data-gridpoints').slice(0, -1)).split(";"),
            isTimeGraph = false,
            html = {
                axis: ""
            };

        if (exampleValue === undefined) return;

        if (graph.data('timegraph')) {
            isTimeGraph = true;
        }

        // charts.each(function(index, val) {
        //     if (!chartValue) {
        //         var chart = $(val),
        //             chartValues = String(chart.data('values')).split(";");
        //
        //         for (var i = 0; i < chartValues.length; i++) {
        //             var value = String(chartValues[i]).replace(/[^0-9\.]+/g,"");
        //
        //             if (!chartValue && !isNaN(value) && value !== "") {
        //                 chartValue = chartValues[i];
        //                 break;
        //             }
        //         }
        //     }
        //     else {
        //         return false;
        //     }
        // });

        // Determine what kind of data and if there's a unit
        numericValue = String(exampleValue).replace(/[^0-9\.]+/g,"");

        if (exampleValue.length !== numericValue.length) {
            index = String(exampleValue).indexOf(numericValue);

            // We have a unit
            if (index !== -1) {
                if (index === 0) {
                    // Unit is at end
                    unitPosition = "end";
                    unit = String(exampleValue).charAt(exampleValue.length-1);
                }
                else {
                    // Unit is at beginning
                    unit = String(exampleValue).charAt(0);
                }
            }
            else {
                if (String(exampleValue).indexOf(':') !== -1) {
                    // Time value
                    isTimeGraph = true;
                }
            }
        }


        // Create the HTML
        if (!isTimeGraph) {
            (function() {
                for (var i = 0; i < labels.length; i++) {
                    var value = numberWithCommas(labels[i]);

                    if (unit !== "") {
                        if (unitPosition == "end") {
                            html.axis = html.axis + '<li><span>'+  value + unit +'</span></li>';
                        }
                        else {
                            html.axis = html.axis + '<li><span>'+ unit + value +'</span></li>';
                        }
                    }
                    else {
                        html.axis = html.axis + '<li><span>'+ value +'</span></li>';
                    }
                }
            })();
        }
        else {
            // Time graph
            (function() {
                var maxValue = graph.data('maxGraphPoint'),
                    maxMinutes = Math.round(secondsToMinutes(maxValue));

                html.axis = html.axis + '<li><span>'+  0  +'</span></li>';
                for (var i = 0; i <= parseInt(maxMinutes / 10, 10); i++) {
                    html.axis = html.axis + '<li><span>'+  10 * (i+1)  +'</span></li>';
                }
            })();
        }

        axisContainer[0].innerHTML = html.axis;
    }

    function charts(container, hasAverage, hasAverageLine, exampleValue) {
        var charts = {},
            wrapper = false,
            averageLine = false;

        if (container !== undefined && container.length) {
            charts = $('.js-chart', container);
            wrapper = $('.js-infochart', container);
        }
        else {
            charts = $('.js-chart', APP.page);
        }

        if (!charts.length) return;

        if (hasAverage === undefined) hasAverage = false;
        if (hasAverageLine === undefined) hasAverageLine = false;


        charts.each(function(index, element) {
            var chart = $(element),
                graph = container || chart.closest('.js-horizontal-barchart-wrapper'),
                chartsWrapper = wrapper || chart.closest('.js-horizontal-barchart'),
                chartIndex = charts.index(chart),
                chartist = null,
                style = chart.data('style'),
                points = [],
                series = [],
                labels = [],
                values = [],
                unit = chart.data('unit'),
                donutTotal = 0,
                chartHeight = '',
                maximumValue,
                i;

            if (chart.attr('data-values')) {
                values = String(chart.attr('data-values')).split(";");
            }

            if (chart.data('points')) {
                // Parse the points
                if (style == 'line') {
                    points = String(chart.data('points')).replace(/,/g, '').split("|");

                    for (i = 0; i < points.length; i++) {
                        points[i] = String(points[i]).replace(/,/g, '').split(";");
                    }
                }
                else {
                    points = String(chart.data('points')).replace(/,/g, '').split(";");
                    points = convertArrayToNumbers(points);
                }

                // Set the series
                if (style == "donut") {
                    for (i = 0; i < points.length; i++) {
                        donutTotal += parseFloat(points[i]);
                    }

                    if (donutTotal < 100) {
                        chart.addClass('chart--donutPartial');
                        points.push(roundToTwo((100-donutTotal)));
                    }

                    series = points;
                }
                else if (style == "bar") {
                    series = [{data: points}];
                }
                else if (style == "line") {
                    for (i = 0; i < points.length; i++) {
                        series[i] = {'data' : points[i]};
                    }
                }
            }


            if (chart.data('labels')) {
                labels = String(chart.data('labels')).split(";");
            }


            if (unit == '%') {
                maximumValue = 100;
            }
            else if (chart.data('max')) {
                maximumValue = chart.data('max');
            }
            else if (chart.data('bar-horizontal') === true && graph.length) {
                maximumValue = graph.data('maxGraphPoint');
            }


            if (chart.data('bar-horizontal')) {
                if (container && container.length) {
                    if (chartIndex === 0) {
                        chartsWrapper.append('<ul class="infograph-axis js-infograph-axis"></ul>');
                    }
                }

                // Set the height manually for horizontal bar charts
                if (chart.data('bar-horizontal-large')) {
                    chartHeight = points.length*64 + 'px';
                }
                else {
                    if (graph.data('ignore-empty-values') === true) {
                        chartHeight = 0;

                        (function() {
                            for (var i = 0; i < points.length; i++) {
                                if (points[i] !== 0) {
                                    chartHeight += 22;
                                }
                            }
                        })();

                        chartHeight = chartHeight + 'px';
                    }
                    else {
                        chartHeight = points.length*22 + 'px';
                    }
                }
            }


            var data = {
                labels: labels,
                series: series
            },
            optionsLineBar = {
                height: chartHeight,
                //low:  unit == '%' ? 0 : undefined,
                low:  0,
                high: maximumValue,
                horizontalBars: chart.data('bar-horizontal') ? true : false,
                ignoreEmptyValues: graph.data('ignore-empty-values') === true ? true : false,
                reverseData: false,
                seriesBarDistance: chart.data('bar-horizontal') ? 0 : 15,
                onlyInteger: false,
                lineSmooth: false,
                fullWidth: true,
                stretch: false,
                chartPadding: {
                    top: chart.data('bar-horizontal') ? 0 : 20,
                    right: chart.data('bar-horizontal') ? 60 : 15,
                    bottom: chart.data('bar-horizontal') ? 0 : 5,
                    left: chart.data('bar-horizontal') ? 0 : 0
                },
                axisX: {
                    type: graph.data('timegraph') ? Chartist.FixedScaleAxis : undefined,
                    offset: chart.data('bar-horizontal') === true ? 0 : 30,
                    showGrid: false,
                    labelInterpolationFnc: function(value, index, total) {
                        if (chart.data('bar-horizontal')) {
                            if (chartIndex === 0 && container && container.length) {
                                if (index === 0) {
                                    chart.attr('data-gridpoints', "");
                                }

                                chart.attr('data-gridpoints', chart.attr('data-gridpoints') + value + ";");

                                if (index == total.length - 1) {
                                    createGraphAxis(container, chartsWrapper, exampleValue);
                                }
                            }

                            return null;
                        }
                        else {
                            return value;
                        }
                    }
                },
                axisY: {
                    position: 'start',
                    labelOffset: {
                      x: 0,
                      y: 0
                    },
                    // low: 0,
                    // type : Chartist.FixedScaleAxis,
                    // ticks: points,
                    offset: style == 'bar' ? 0 : 50,
                    labelInterpolationFnc: function(value, index) {
                        if (style == 'bar') {
                            return null;
                        }
                        else {
                            if (unit) {
                                return roundToTwo(value) + unit;
                            }
                            else {
                                return roundToTwo(value);
                            }
                        }
                    }
                }
            },
            optionsDonut = {
                onlyInteger: false,
                donut:  true,
                donutWidth: 35,
                donutSolid: true,
                //startAngle: 90,
                //total: 100,
                showLabel: false,
                lineSmooth: false,
                fullWidth: true,
                stretch: false,
                chartPadding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            };


            // Bar charts
            if (style == 'bar') {
                chartist = Chartist.Bar(chart[0], data, optionsLineBar);

                if (graph.length && hasAverage) {
                    graph.addClass('has-average');

                    if (hasAverageLine && !averageLine) {
                        averageLine = $('<span class="average-line"></span>');

                        chartsWrapper.append(averageLine);
                    }
                }

                // Hopefully fix incorrect chart sizes on page load by forcing an update
                if (container !== undefined) {
                    setTimeout(function(){
                        chartist.update();
                    }, 1000);
                }

                chartist.on('draw', function(event) {
                    var barHorizontalCenter, barVerticalCenter, label, value;

                    // Centers the horizontal labels for browsers that don't support foreignobject
                    if (!chartist.supportsForeignObject && event.type === 'label' && event.axis.units.pos === 'x') {
                        event.element.attr({
                            x: event.x + event.width / 2,
                            'style' : 'text-anchor: middle;'
                        });
                    }

                    // Adds value label on top of the bar
                    if (event.type === "bar") {
                        if (!chart.data('bar-horizontal')) {
                            barHorizontalCenter = event.x1;
                            barVerticalCenter = event.y1 + (event.element.height() * -1) - 5;

                            if (bowser.msedge || bowser.msie) {
                                barVerticalCenter += 25;
                            }
                        }
                        else {
                            barHorizontalCenter = event.x1 + event.element.width() + 5;
                            barVerticalCenter = event.y1 + 5;

                            if (bowser.msedge || bowser.msie)  {
                                if (chart.data('bar-horizontal-large')) {
                                    barHorizontalCenter -= 60;
                                }
                                else {
                                    barHorizontalCenter -= 20;
                                }
                            }

                            if (graph.length && charts.index(chart) === 0 && averageLine) {
                                averageLine.css('left', Math.floor(event.x2));
                            }
                        }

                        if (values.length) {
                            value = values[event.index];
                        }
                        else {
                            value = event.element.attr('ct:value');
                        }

                        if (graph.data('max')) {
                            var val = 0,
                                arrow;

                            if (graph.data('timegraph')) {
                                if (value !== "") {
                                    val = hmsToSecondsOnly(value);
                                }
                            }
                            else {
                                val = value;
                            }

                            if (val > graph.data('maxGraphPoint')) {
                                arrow = new Chartist.Svg('text');
                                arrow.text('>>>');
                                arrow.addClass("ct-bararrow");
                                arrow.attr({
                                    x: barHorizontalCenter - 40,
                                    y: barVerticalCenter,
                                    'text-anchor': 'middle'
                                });

                                event.group.append(arrow);
                            }
                        }

                        //if (value !== '0') {
                            label = new Chartist.Svg('text');
                            label.text(numberWithCommas(value));
                            label.addClass("ct-barlabel");
                            label.attr({
                                x: barHorizontalCenter,
                                y: barVerticalCenter,
                                'text-anchor': 'middle'
                            });

                            return event.group.append(label);
                        //}
                    }
                });
            }

            // Line Charts
            else if (style == 'line') {
                chartist = Chartist.Line(chart[0], data, optionsLineBar);

                // Centers the horizontal labels
                chartist.on('draw', function(event) {
                    if (event.type === 'label' && event.axis.units.pos === 'x') {

                        if (chartist.supportsForeignObject) {
                            event.element.attr({
                                x: event.x - event.width / 2
                            });
                        }
                        else {
                            event.element.attr({
                                x: event.x,
                                'style' : 'text-anchor: middle;'
                            });
                        }
                    }


                    // Replacing the dots
                    if (event.type === 'point') {
                        var circle = new Chartist.Svg('circle', {
                            cx: event.x,
                            cy: event.y,
                            r:  3,
                            style: 'fill-opacity: 1; fill: #fff; stroke-width: 2px;'
                        }, 'ct-area');


                        event.element.replace(circle);
                    }
                });
            }
            else if (style == 'donut') {
                chartist = new Chartist.Pie(chart[0], data, optionsDonut);
            }
        });
    }

    function toggleAccordion(panels) {
        var timingFunction = 'cubic-bezier(0.250, 0.250, 0.105, 1.365)',
            duration = 350;

        panels = panels || $('.js-panel', APP.page);

        if (panels.length) {
            panels.each(function(index, value) {
                var panel = $(value),
                    button = panel.find(selectByBehaviour('accordion-control')),
                    target = $('.js-panel-content', panel),
                    heading = $('.js-panel-heading', panel).eq(0),
                    targetContent = target.find(selectByBehaviour('accordion-content')),
                    targetId = 'panel-' + index,
                    headingId = 'heading-' + index,
                    slider = target.closest('.js-slides'),
                    isInsideSlider = slider.length ? true : false,
                    expanded = panel.data('expanded');

                // Setup the ARIA attributes
                button.attr('href', '#' + targetId).attr('aria-controls', targetId).attr('aria-expanded', expanded);
                heading.attr('id', headingId);
                target.attr('id', targetId).attr('aria-labelledby', headingId).attr('aria-hidden', !expanded);

                button.on('click', function(e) {
                    e.preventDefault();

                    if (target.length && targetContent.length) {
                        var targetContentHeight = targetContent.outerHeight(true),
                            targetContentOffset = targetContent.offset().top,
                            panelOffset = panel.offset().top,
                            targetBottom = targetContentOffset + targetContentHeight,
                            scrollPosition = 0;

                        if (panel.data('expanded') !== true) {
                            if (panel.data('animating') !== true && win.data('scrolling') !== true) {
                                panel.data('animating', true);

                                target.attr('aria-hidden', 'false');
                                button.attr('aria-expanded', 'true');
                                panel.data('expanded', true).attr('data-expanded', 'true');

                                if (!isInsideSlider) {
                                    target.transition({
                                        height: targetContentHeight,
                                        transform: 'translateZ(0)',
                                        duration: duration,
                                        easing: timingFunction,
                                        complete: function() {
                                            target.css('height', 'auto');
                                            panel.data('animating', false);
                                        }
                                    });

                                    if ((win.data('scrollPosition') + win.data('height')) < targetBottom) {
                                        scrollPosition = (targetBottom - win.data('height')) > panelOffset ? panelOffset - APP.Elements.header.data('height') - 50 : targetBottom - win.data('height');
                                        animatedScrollPageTo(scrollPosition, 350);
                                    }
                                }
                                else {
                                    target.css('height', 'auto');
                                    slider.slick('setPosition');
                                    panel.data('animating', false);
                                }
                            }
                        }
                        else {
                            if (panel.data('animating') !== true && win.data('scrolling') !== true) {
                                panel.data('animating', true);

                                target.attr('aria-hidden', 'true');
                                button.attr('aria-expanded', 'false');
                                panel.data('expanded', false).attr('data-expanded', 'false');

                                if (!isInsideSlider) {
                                    target.css('height', targetContentHeight);
                                    target.transition({
                                        height: 0,
                                        transform: 'translateZ(0)',
                                        duration: duration,
                                        easing: timingFunction,
                                        complete: function() {
                                            target.css('height', '');

                                            panel.data('animating', false);
                                        }
                                    });
                                }
                                else {
                                    target.css('height', '');
                                    slider.slick('setPosition');
                                    panel.data('animating', false);
                                }
                            }
                        }
                    }
                });
            });
        }
    }


    function infopanels() {
        var panels = $('.js-infopanel', APP.page),
            openButtons = $('.js-infopanel-open', APP.page);

        if (!panels.length) return;

        var template = {
            graph: Handlebars.compile($("#infopanel-graph-template").html()),
            legend: Handlebars.compile($("#infopanel-legend-template").html()),
            stars: Handlebars.compile($("#infopanel-stars-template").html())
        };

        panels.each(function(index_panel, value) {
            var panel = $(value),
                graphs = $('.js-infograph', panel);

            graphs.each(function(index_graph, value) {
                var graph = $(value);

                parseGraph(graph, panel, index_graph, graphs.length - 1, index_panel);
            });
        });

        function parseGraph(graph, panel, index_graph, index_graph_last, index_panel) {
            Papa.parse(location.protocol + '//' + location.host + "/csv/" + graph.data('csv'), {
                download: true,
                header: false,
                skipEmptyLines: true,
                complete: function(results) {
                    var table = results.data;

                    populateGraph(graph, results.data);

                    // Last graph in the panel
                    if (index_graph == index_graph_last) {
                        initPanelTabs(panel);
                        initPanelSlider(panel);
                        initPanelToggle(panel, index_panel);

                        if (index_panel === 0) {
                            setTimeout(function() {
                                takeAPeek(panel);
                            }, 500);
                        }
                    }
                }
            });
        }

        function populateGraph(graph, table) {
            var chartsWrapper = $('.js-infochart', graph),
                legend = $('.js-chart-legend', graph),
                hasAverage = false,
                hasAverageLine = false,
                averageIndex = 0,
                isStarsGraph = false,
                exampleValue = 0;

            var data = {
                    headers: [],
                    companies: {}
                },
                html = {
                    chart: "",
                    legend: ""
                };

            // Populate the headers object
            for (var n = 1; n < table[2].length; n++) {
                // If we've got a header
                if (table[1][n]) {
                    data.headers.push(table[1][n]);
                }
                else {
                    data.headers.push(n);
                }
            }

            // Create the legend HTML
            for (var y = 0; y < data.headers.length; y++) {
                // Actual vs target detection
                if (data.headers[y].indexOf("Actual") !== -1 || data.headers[y].indexOf("Gwirioneddol") !== -1) {
                    if (data.headers[y+1].indexOf("Target") !== -1 || data.headers[y+1].indexOf("Targed") !== -1) {
                        graph.addClass('is-actual-vs-target');
                    }
                }

                if (legend.length) {
                    html.legend = html.legend + template.legend({
                        legend: data.headers[y]
                    });
                }
            }


            // Populate the companies object
            for (var r = 2; r < table.length; r++) {
                var row_company = table[r];

                // If we've got a value (company name)
                if (row_company[0] !== " ") {
                    data.companies[row_company[0]] = {};

                    for (n = 1; n < row_company.length; n++) {
                        // Average detection
                        if (!hasAverage && (row_company[0] == "Average" || row_company[0] == "Cyfartaledd")) {
                            hasAverage = true;

                            averageIndex = r;

                            if (row_company.length == 2) {
                                hasAverageLine = true;
                            }
                        }

                        data.companies[row_company[0]][data.headers[n-1]] = row_company[n];
                    }
                }
                else {
                    break;
                }
            }

            function generateMarkup(companies) {
                $.each(companies, function(company, companyData) {
                    var values = '',
                        points = '',
                        stars = '';

                    $.each(companyData, function(header, value) {
                        if (value.indexOf(':') == -1) {
                            // Not time data
                            if (value.indexOf('*') == -1) {
                                // Not star data - general data

                                // Value is not empty
                                if (value !== "") {
                                    // If it's a number
                                    if (!isNaN(parseFloat(value.replace(/[^0-9\.]+/g,""), 10))) {
                                        points = parseFloat(value.replace(/[^0-9\.]+/g,""), 10) + ';' + points;
                                    }
                                    else {
                                        points = 0 + ';' + points;
                                    }
                                }
                                else {
                                    points = 0 + ';' + points;
                                }
                            }
                            else {
                                // Star data
                                if (!isStarsGraph) {
                                    isStarsGraph = true;
                                }
                                if (value === "") {
                                    value = 0;
                                }

                                (function() {
                                    var count = parseInt(value, 10);

                                    stars = stars + '<div class="stars-column"><div class="stars-item stars-container">';

                                    for (var i = 1; i <= count; i++) {
                                        stars = stars + '<span class="star star--full"><svg role="presentation"><use xlink:href="/assets/images/icons.svg#star-flat"/></svg></span>';
                                    }

                                    if (count < 4) {
                                        for (var n = 1; n <= 4 - count; n++) {
                                            stars = stars + '<span class="star star--empty"><svg role="presentation"><use xlink:href="/assets/images/icons.svg#star-empty"/></svg></span>';
                                        }
                                    }

                                    stars = stars + '</div></div>';
                                })();
                            }
                        }
                        else {
                            // Time data
                            graph.data('timegraph', true);
                            points = hmsToSecondsOnly(value) + ';' + points;
                        }


                        values = value + ';' + values;

                        if (value !== 0 && value !== "" && value !== 'N/A') {
                            exampleValue = value;
                        }
                    });

                    // Trim the last ";"
                    if (points !== '') {
                        points = points.slice(0, -1);
                    }
                    if (values !== '') {
                        values = values.slice(0, -1);
                    }

                    if (points == '0') {
                        points = '0.000001';
                    }

                    if (values.length === 0) {
                        values = " ";
                    }

                    // Create the markup
                    if (!isStarsGraph) {
                        html.chart = html.chart + template.graph({
                            company: company,
                            points: points,
                            values: values
                        });
                    }
                    else {
                        html.chart = html.chart + template.stars({
                            company: company,
                            stars: stars
                        });
                    }
                });
            }

            // Generate the markup
            generateMarkup(data.companies);
            if (hasAverage && !isStarsGraph) {
                (function(){
                    var averageData = {};
                    averageData[table[averageIndex][0]] = data.companies[table[averageIndex][0]];
                    generateMarkup(averageData);
                })();
            }

            // Prep the HTML
            if (!isStarsGraph) {
                chartsWrapper.addClass('horizontal-barchart');
            }
            else {
                chartsWrapper.addClass('starchart');
                graph.addClass('stargraph');

                if (data.headers.length == 1) {
                    graph.addClass('stargraph--single');
                }

                html.chart = '<div class="starchart-inner">' + html.chart + '</div>';
            }


            // Insert the HTML
            chartsWrapper.append(html.chart);

            if (isStarsGraph && data.headers.length > 1) {
                legend = $('.js-chart-legend', graph);
            }

            if (legend.length) {
                legend.append(html.legend);
            }



            // Init graph JS
            getMaxGraphValue(graph);
            charts(graph, hasAverage, hasAverageLine, exampleValue);
        }


        function stickySliderArrows(panel) {
            var arrows = $('.slick-arrow', panel),
                slider = $('.js-infopanel-slides', panel).eq(0),
                arrowHeight = 0,
                sliderOffset = 0,
                sliderHeight = 0;

            // Get positions
            function getPositions() {
                arrowHeight = arrows.outerHeight();
                sliderOffset = slider.offset().top;
                sliderHeight = slider.outerHeight();
            }
            getPositions();
            win.on("resize", function() {
                getPositions();
            });

            function update() {
                //if (panel.data('expanded')) {
                    var position = win.data('scrollPosition') + win.data('height')/2 - sliderOffset;

                    if (position <= 0) {
                        arrows.addClass('is-pinned-top');
                    }
                    else {
                        if (position >= sliderHeight - arrowHeight) {
                            arrows.addClass('is-pinned-bottom');
                        }
                        else {
                            arrows.removeClass('is-pinned-top is-pinned-bottom');
                        }
                    }
                //}
            }
            update();
            win.on("scroll", function() {
                update();
            });

            slider.on('setPosition', function() {
                getPositions();
                update();
            });
        }

        function initPanelSlider(panel) {
            var nav = $('.js-infopanel-nav', panel),
                slides = $('.js-infopanel-slides', panel),
                footer = $('.js-infopanel-footnotes', panel),
                isIE = (bowser.msedge || bowser.msie) ? true : false,
                speed = isIE ? 0 : 300,
                fade = isIE ? true : false;

            // If we don't have a graph on the first slide hide the footer buttons
            if (!slides.children('.js-infopanel-slide').eq(0).find('.js-infochart').length) {
                footer.addClass('is-hidden');
            }

            slides.on('init', function(slick) {
                stickySliderArrows(panel);
            });

            slides.add(nav).on('pageload', function() {
                slides.add(nav).slick('unslick');
            });

            slides.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: fade,
                speed: speed,
                adaptiveHeight: true,
                infinite: false,
                asNavFor: nav,
                draggable: false,
                swipe: APP.touch,
                touchMove: false,
                arrows: true,
                prevArrow: '<a role="button"><svg class="icon" role="presentation"><use xlink:href="/assets/images/icons.svg#arrow-thin-left"/></svg></a>',
                nextArrow: '<a role="button"><svg class="icon" role="presentation"><use xlink:href="/assets/images/icons.svg#arrow-thin-right"/></svg></a>'
            });

            slides.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                // Toogle footer buttons depending on graph presence
                if (!slides.eq(nextSlide).find('.js-infochart').length) {
                    if (footer.hasClass('is-hidden')) {
                        footer.removeClass('is-hidden');
                    }
                }
                else {
                    if (!footer.hasClass('is-hidden')) {
                        footer.addClass('is-hidden');
                    }
                }
            });

            nav.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: slides,
                dots: false,
                arrows: false,
                centerMode: false,
                variableWidth: true,
                focusOnSelect: true
            });
        }

        function initPanelTabs(panel) {
            var containers = $('.js-tabs', panel),
                slider = panel.find('.js-infopanel-slides');

            containers.each(function(index, value) {
                var container = $(value),
                    tabs = $('.js-tab', container),
                    panels = $('.js-tabs-panel', container);

                // Setup ARIA attributes, activate the first one
                tabs.add(panels).attr('aria-expanded', false);
                tabs.eq(0).addClass('is-active').attr('aria-expanded', true);
                panels.eq(0).addClass('is-active').attr('aria-expanded', true);

                panels.eq(0).find('.ct-chart').each(function(index, element) {
                    element.__chartist__.update();
                });

                tabs.on('click', function(e) {
                    e.preventDefault();

                    var tab = $(this),
                        index = tabs.index(tab),
                        panel = panels.eq(index);

                    if (!tab.hasClass('is-active')) {
                        tabs.not(tab).add(panels.not(panel)).removeClass('is-active').attr('aria-expanded', false);
                        tab.add(panel).addClass('is-active').attr('aria-expanded', true);

                        slider.slick('setPosition');

                        panel.find('.ct-chart').each(function(index, element) {
                            element.__chartist__.update();
                        });

                        slider.slick('setPosition');
                    }
                });
            });
        }

        function initPanelToggle(panel, index_panel) {
            var openButton = openButtons.eq(index_panel),
                closeButton = $('.js-infopanel-close', panel);

            // Setup the ARIA attributes
            openButton.attr('aria-expanded', false);
            panel.attr('aria-expanded', false);

            // Bind event handlers
            openButton.on('click', function(e) {
                e.preventDefault();

                openPanel(panel);
            });

            closeButton.on('click', function(e) {
                e.preventDefault();

                closePanel(panel);
            });

            function openPanel(panel) {
                var panelInner = $('.js-infopanel-inner', panel),
                    panelContainer = panel.closest('.js-infopanels'),
                    panelIndex = panels.index(panel),
                    openButton = openButtons.eq(panelIndex);

                if (panelContainer.data('animating') !== true && win.data('scrolling') !== true) {

                    if (panel.data('expanded') !== true) {
                        var activePanelInContainer = panel.siblings('.js-infopanel').filter(selectDataString('expanded', true));

                        if (activePanelInContainer.length) {
                            closePanel(activePanelInContainer, false, function() {
                                openPanel(panel);
                            });

                            return;
                        }
                        else {
                            panelContainer.data('animating', true);

                            animatedScrollPageTo(panelContainer.offset().top - APP.Elements.header.data('height') - 100, false);

                            setTimeout(function() {
                                panelContainer.addClass('is-expanded');
                            }, 50);

                            openButton.addClass('is-expanded').attr('aria-expanded', 'true');

                            var open = function() {
                                panel.css('height', 'auto').css('transform', '');
                                panelContainer.data('animating', false);

                                panel.attr('aria-expanded', 'true');
                                panel.attr('data-expanded', 'true').data('expanded', true);
                            };


                            if (bowser.msedge || bowser.msie) {
                                open();
                            }
                            else {
                                panel.transition({
                                    height: panelInner.outerHeight(true),
                                    transform: 'translateZ(0)',
                                    duration: 350,
                                    easing: 'ease',
                                    complete: function() {
                                        open();
                                    }
                                });
                            }


                        }
                    }
                    else {
                        closePanel(panel);
                    }
                }
            }

            function closePanel(panel, collapseContainer, callback) {
                var panelInner = $('.js-infopanel-inner', panel),
                    panelContainer = panel.closest('.js-infopanels'),
                    panelIndex = panels.index(panel),
                    openButton = openButtons.eq(panelIndex);

                if (collapseContainer === undefined) {
                    collapseContainer = true;
                }

                if (panel.data('expanded') === true && panelContainer.data('animating') !== true && win.data('scrolling') !== true) {
                    panelContainer.data('animating', true);

                    if (collapseContainer) {
                        panelContainer.removeClass('is-expanded');
                    }

                    openButton.removeClass('is-expanded').attr('aria-expanded', 'false');
                    panel.attr('aria-expanded', 'false');
                    panel.attr('data-expanded', 'false').data('expanded', false);

                    panel.height(panel.height());

                    var close = function() {
                        panel.css('height', '').css('transform', '');
                        $('.js-infopanel-nav', panel).find('.slick-slide').eq(0).click();
                        panelContainer.data('animating', false);

                        if (callback && typeof callback === 'function') {
                            callback();
                        }
                    };

                    if (bowser.msedge || bowser.msie) {
                        close();
                    }
                    else {
                        panel.transition({
                            height: 0,
                            transform: 'translateZ(0)',
                            duration: 200,
                            easing: 'ease',
                            complete: function() {
                                close();
                            }
                        });
                    }
                }
            }
        }

        function takeAPeek(panel) {
            if (bowser.msedge || bowser.msie) return;

            var openButton = $('.js-infopanel-open', APP.page).eq(0),
                panelInner = $('.js-infopanel-inner', panel),
                panelContainer = panel.closest('.js-infopanels');

            if (panel.data('expanded') !== true && panelContainer.data('animating') !== true && win.data('scrolling') !== true) {
                panelContainer.data('animating', true);

                panel.addClass('peekaboo');
                openButton.addClass('is-expanded peekaboo');

                panel.transition({
                    height: '68px',
                    transform: 'translateZ(0)',
                    duration: 350,
                    easing: 'ease',
                    complete: function() {
                        setTimeout(function() {
                            panel.transition({
                                height: 0,
                                transform: 'translateZ(0)',
                                duration: 200,
                                easing: 'ease',
                                complete: function() {
                                    openButton.removeClass('is-expanded peekaboo');
                                    panel.css('height', '').css('transform', '');
                                    panel.removeClass('peekaboo');
                                    panelContainer.data('animating', false);
                                }
                            });
                        }, 350);
                    }
                });
            }
        }

        // function printPanel(panel) {
        //     var template = Handlebars.compile($("#infopanel-print-template").html()),
        //         container = $('#print-styles').eq(0),
        //         button = $('.js-print-panel', panel),
        //         charts = $('.ct-chart', panel);
        //
        //         // update and resize chart when printing
        //         var chartScale = function (charts) {
        //             charts.each(function(index, value) {
        //                 var chart = $(value);
        //
        //                 // Firefox printing bug workaround
        //                 if (bowser.firefox) {
        //                     var svg = $('.ct-chart-bar', chart)[0],
        //                         width = svg.getBBox().width,
        //                         factor = 565 / width; // width of printable area(75dpi) / width of chart
        //
        //                     svg.setAttribute("transform", "scale("+factor+")");
        //                     setTimeout(function () {
        //                         svg.setAttribute("transform", "");
        //                     }, 10);
        //                 } else {
        //                     // this works in Chrome & latest Opera
        //                     chart.update();
        //                 }
        //             });
        //         };
        //
        //         // fix printing for different browsers
        //         var preparePrintChart = function () {
        //             if (window.matchMedia) {
        //                 window.matchMedia('print').addListener(function() {
        //                     chartScale(charts);
        //                 });
        //             }
        //
        //             window.onbeforeprint = function () {
        //                 chartScale(charts);
        //             };
        //         };
        //         preparePrintChart();
        //
        //
        //         button.on('click', function(e) {
        //             e.preventDefault();
        //
        //             container.html(template({
        //                 panelID: panel.attr('id')
        //             }));
        //
        //
        //
        //             window.print();
        //
        //             setTimeout(function(){
        //                 container.empty();
        //             }, 100);
        //         });
        // }


    }

    // function setupPanelsID() {
    //     var panels =  $('.js-infopanel', APP.page);
    //
    //     if (!panels.length) return;
    //
    //     panels.each(function(index, value) {
    //         var panel = $(value);
    //
    //         panel.attr('id', 'panel-' + index);
    //     });
    // }


    // function socialSharing() {
    //     var elements = $('.js-sharetastic', APP.page);
    //
    //     elements.sharetastic({
    //         sprite: '/assets/images/sharetastic.svg',
    //         services: {
    //             email: {
    //                 order: 0
    //             },
    //             twitter: {
    //                 order: 1
    //             },
    //             facebook: {
    //                 order: 2
    //             },
    //             pinterest: false,
    //             print: false,
    //             tumblr: false,
    //             instagram: false,
    //             linkedin: false,
    //             googleplus: false,
    //             flickr: false
    //         }
    //     });
    // }

    // function sendFeedback() {
    //     var forms = $('.js-feedback-form', APP.page);
    //
    //     if (forms.length) {
    //         forms.each(function(index, value) {
    //             var form = $(value),
    //                 inputs = $('input', form),
    //                 successMessage = $('.js-response-success', form),
    //                 errorMessage = $('.js-response-error', form),
    //                 slider = form.closest('.js-slides');
    //
    //             form.on("submit", function(e) {
    //                 e.preventDefault();
    //
    //                 if (form.data('submitted') !== true) {
    //                     var data = $(this).serialize(),
    //                         vote = inputs.not(':checked').closest('.js-vote');
    //
    //                     inputs.attr('disabled', 'disabled');
    //                     errorMessage.add(successMessage).removeClass('is-visible');
    //
    //                     $.post('/', data, function(response) {
    //                         if (response.success) {
    //                             form.addClass('is-submitted').data('submitted', true);
    //                             vote.addClass('is-hidden');
    //                             errorMessage.removeClass('is-visible');
    //                             successMessage.addClass('is-visible');
    //                         } else {
    //                             form.removeClass('is-submitted').data('submitted', false);
    //                             inputs.removeAttr('disabled').prop('checked', false);
    //                             successMessage.removeClass('is-visible');
    //                             errorMessage.addClass('is-visible');
    //                         }
    //                         slider.slick('setPosition');
    //                     });
    //                 }
    //             });
    //
    //             inputs.on('change', function() {
    //                 form.submit();
    //             });
    //
    //         });
    //     }
    // }


    function postForm(containers) {
        containers = containers || $('.js-form', APP.page);

        if (containers.length) {
            containers.each(function(index, value) {
                var container = $(value),
                    form = container.find('form'),
                    button = $('.js-submit-button', form),
                    successMessage = $('.js-response-success', container),
                    errorMessage = $('.js-response-error', container);

                // Validation
                $('form').parsley();

                // Form submission
                form.on("submit", function(e) {
                    e.preventDefault();

                    // Get the post data
                    var data = $(this).serialize();

                    button.attr('disabled', 'disabled');

                    // Send it to the server
                    $.post('/', data, function(response) {
                        if (response.success) {
                            button.addClass('is-invisible');
                            errorMessage.removeClass('is-visible');
                            successMessage.addClass('is-visible');

                            setTimeout(function(){
                                $.fancybox.close();
                            }, 1000);

                        } else {
                            // response.error will be an object containing any validation errors that occurred, indexed by field name
                            // e.g. response.error.fromName => ['From Name is required']
                            button.removeAttr('disabled');
                            successMessage.removeClass('is-visible');
                            errorMessage.addClass('is-visible');
                        }
                    });
                });
            });
        }
    }

    function fancyBox() {
        var links = $('.js-leave', APP.page);

        if (!links.length) return;

        links.each(function(index, value) {
            var link = $(value),
                href = link.attr('href'),
                lightbox = $(href),
                stayButton = $('.js-stay', lightbox);

            if (!lightbox.length) return;

            link.fancybox({
                fitToView: true,
                maxWidth: '600px',
                closeClick: false,
                openEffect: 'none',
                closeEffect: 'none',
                closeBtn: false,
                padding: 0,
                tpl: {
                    loading : '<div id="fancybox-loading"><svg class="spinner" viewBox="0 0 50 50"><circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg></div>'
                },
                beforeShow: function() {
                    APP.Elements.body.css({'overflow-y':'hidden'});
                },
                afterClose: function() {
                    APP.Elements.body.css({'overflow-y':'visible'});
                },
                afterLoad: function() {

                }
            });

            stayButton.on('click', function(e) {
                e.preventDefault();

                $.fancybox.close();
            });
        });
    }

    function scrollToAnchor() {
        var scroll = function() {
            if (window.location.hash.length) {
                var hash = window.location.hash,
                    target = $(hash),
                    targetPosition = 0;

                if (!target.length) return;

                targetPosition = target.offset().top - APP.Elements.header.data('height') - 30;

                animatedScrollPageTo(targetPosition);
            }
        };

        setTimeout(function() {
            scroll();
        }, 250);
    }

    function openContactLightbox() {
        var links = $('.js-open-contact-lightbox', APP.page);

        if (!links.length) return;

        links.each(function(index, value) {
            var link = $(value);

            link.fancybox({
                type: 'ajax',
                fitToView: true,
                minWidth: '100%',
                closeClick: false,
                openEffect: 'none',
                closeEffect: 'none',
                closeBtn: true,
                padding: 20,
                tpl: {
                    loading : '<div id="fancybox-loading"><svg class="spinner" viewBox="0 0 50 50"><circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg></div>'
                },
                beforeShow: function() {
                    APP.Elements.body.css({'overflow-y':'hidden'});
                },
                afterClose: function() {
                    APP.Elements.body.css({'overflow-y':'visible'});
                },
                afterLoad: function() {

                },
                afterShow: function() {
                    postForm($('.js-form'));
                }
            });
        });
    }

    function destroyLightboxesLeftover() {
        $(document).unbind('click.fb-start');
        $('.fancybox-overlay').remove();
    }


    function initAfterDashboardAnimation() {
        APP.page = $('.js-page').eq(0);

        scrollToAnchor();
        infopanels();
    }

    function init() {
        APP.page = $('.js-page').eq(0);

        if (APP.page.length) {
            counters(APP.page);

            getMaxGraphValue();
            charts();

            polyfillSVG();
            toggleAccordion();

            //socialSharing();

            //sendFeedback();
            postForm();

            destroyLightboxesLeftover();
            fancyBox();
            openContactLightbox();

            //setupPanelsID();

            if (!APP.MODULES.dashboard.loaded) {
                initAfterDashboardAnimation();
            }
        }
    }

    return {
        init: init,
        counters: counters,
        polyfillSVG: polyfillSVG,
        initAfterDashboardAnimation: initAfterDashboardAnimation
    };
}();
